import { NgModule } from '@angular/core';

import { GLinkHighlightComponent } from 'app/core/components/highlight/highlight.component';

@NgModule({
    declarations: [
        GLinkHighlightComponent
    ],
    exports: [
        GLinkHighlightComponent
    ],
})
export class GLinkHighlightModule
{
}
